import PropTypes from 'prop-types';
import VendorsComponent from 'modules/shared/vendors/components/VendorsComponent';

const VendorsContainer = props => <VendorsComponent {...props} />;

VendorsContainer.propTypes = {
  stringsData: PropTypes.shape({}).isRequired,
};

VendorsContainer.defaultProps = {};

export default VendorsContainer;
